import { getPath } from '@/router/common'
const baseUrl = {
  title: '出库登记',
  path: 'ckRegister'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'ckRegister_Index',
    component: () => import(/* webpackChunkName: "ckRegister_Index" */ '@/views/ckRegister/index.vue'),
    meta: {
      title: '出库登记'
    }
  },
  {
    path: getPath('ckSingle', baseUrl),
    name: 'ckRegister_ckSingle',
    component: () => import(/* webpackChunkName: "ckRegister_ckSingle" */ '@/views/ckRegister/ckSingle.vue'),
    meta: {
      title: '出库登记-单票登记'
    }
  },
  {
    path: getPath('ckInfo', baseUrl),
    name: 'ckRegister_ckInfo',
    component: () => import(/* webpackChunkName: "ckRegister_ckInfo" */ '@/views/ckRegister/ckInfo.vue'),
    meta: {
      title: '登记出库'
    }
  }
]
